export enum ClusterState {
  UNKNOWN = 'Unknown',
  LAUNCH_FAILED = 'Launch Failed',
  STOPPED = 'Stopped',
  LAUNCHING = 'Launching',
  DESTROYING = 'Destroying',
  DESTROY_FAILED = 'Destroy Failed',
}
